import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { InvoiceListIssuedComponent } from './invoice-list-issued.component';
import { InvoiceService } from './invoice.service';
import * as FileSaver from 'file-saver';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvoiceModel } from './invoice.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { ContactBankAccountService } from '../../contact/contactbankaccounts/contactbankaccount.service';
import { consts } from '../../../consts';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { ResultModel } from '../../../shared/result.model';

@Component({
    selector: 'convfact-invoicesepa',
    templateUrl: './invoice-dialog-sepa.component.html',
    styleUrls: ['./invoice.component.css'],
    standalone: false
})

export class InvoiceDialogSepaComponent implements OnInit {

    type: string = this.data.type;
    invoicesCSV: string[] = this.data.invoicesCSV;
    errors: string[] = [];
    error = false;
    ready = false;
    working = false;

    constructor(
        public dialogRef: MatDialogRef<InvoiceListIssuedComponent>,
        public invoiceService: InvoiceService,
        public contactService: ContactService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public contactBankAccountService: ContactBankAccountService,
        public bankAccountService: BankAccountService,
        public snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.invoicesCSV.forEach(invoice => {
            let invoiceVar: InvoiceModel;
            this.invoiceService.loadData(invoice).then(responseInvoice => {
                invoiceVar = responseInvoice;
                this.contactService.loadData(invoiceVar.receiverUid).then(responseClient => {
                    let contactVar: ContactModel;
                    contactVar = responseClient;
                    this.contactBankAccountService.getList(contactVar.uid).then(response => {
                        // if (response.length === 0) {
                        //     let error = '';
                        //     error = contactVar.companyName + ' no tiene una cuenta bancaria dada de alta';
                        //     this.errors.push(error);
                        //     this.error = true;
                        // }
                        this.ready = true;
                    });
                });
            });
        });
    }

    remesa() {
        this.working = true;
        let ok = false;
        //Comprobamos que el usuario tiene una cuenta asignada a las remesas
        let bankAccount: ResultModel<BankAccountModel>;
        this.bankAccountService.getList().then(response => {
            bankAccount = response;
            bankAccount.list.forEach(element => {
                if (element.remesa) {
                    ok = true;
                }
            })

            if (ok) {
                const self = this;
                this.invoiceService.sepa(this.invoicesCSV, this.type).then(response => {
                    FileSaver.saveAs(response, 'remesa.xml');
                    self.dialogRef.close();
                }).catch(err => {
                    err['errors'].forEach(test => {
                        console.log(test);
                    })

                    console.log("Tipo de err:", typeof err);
                    console.log("Keys de err:", Object.keys(err));
                    console.log("Contenido err:", err);
                    self.errors = err.errors;


                });

            } else {
                this.displayInfo("No dispone de una cuenta bancaria configurada para remesa, dirígase a Finanzas -> Bancos, para asignarla.")
            }
        });
        this.working = false;
    }

    public displayInfo(response: string): void {
        const options = new MatSnackBarConfig();
        const self = this;
        options.duration = 10500;
        this.snackBar.open(response, '', options);
    }

    closeDialog() {
        this.dialogRef.close();
    }
  public trackByIndex(i: number) { return i; }

}
